import React from 'react'
import { IoIosArrowForward, IoIosArrowDown } from 'react-icons/io'
import { Col, Row } from 'reactstrap'

const PathogenSyndromicTesting = () => {
  return (
    <div id='website-responsive'>
    <div className='left-padding5rem1 right-padding5rem1 py-md-5 py-4'>
        <div className=''>
            <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                Syndromic Testing from United Lab Care
            </div>
            <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>

        </div>

        <div className='py-3'>
            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
            Syndromic testing with United Lab care combines a wide variety of likely respiratory pathogens into a single thorough, quick test, assisting physicians in making better decisions and offering better patient care.
            </div>
        </div>

        <div className='pt-md-4 pt-3'>
            <Row  className='flex-center'>
                <Col sm='12' md='12' lg='' className='flex-center pb-md-4 pb-lg-5 pb-3'>
                    <div className='flex-center'>
                    <div className='grid-center'>
                    <center>
                        <img src='pathogen-testing/RPP-Testing-Workflow-icon1.png' alt='' height='auto' width='80px'  />
                        <div className='flex-center fw-500 text-montserrat text-ss-black fs-ss-16 pt-2'>One sample</div>
                        </center>
                        <div className='mt-4  d-flex justify-content-center'>
                                <IoIosArrowDown className='fs-ss-36 text-ss-primary fw-800 display-block1-1'/>
                            </div>
                        </div>
                    </div>
                        <div className='ms-md-4'>
                            <IoIosArrowForward className='fs-ss-36 text-ss-primary fw-800 display-none'/>
                        </div>
                    </Col>
                    <Col sm='12' md='12' lg='' className='flex-center pb-md-4 pb-lg-5 pb-3'>
                    <div className='flex-center'>
                    <div className='grid-center'>
                    <center>
                        <img src='pathogen-testing/RPP-Testing-Workflow-icon6.png' alt='' height='auto' width='50%'  />
                        <div className='flex-center fw-500 text-montserrat text-ss-black fs-ss-16 lh-1-2 pt-2'><center>Multiple tests<br/> ordered </center></div>
                        </center>
                        <div className='mt-4  d-flex justify-content-center'>
                                <IoIosArrowDown className='fs-ss-36 text-ss-primary fw-800 display-block1-1'/>
                            </div>
                        </div>
                    </div>
                        <div className='ms-md-4'>
                            <IoIosArrowForward className='fs-ss-36 text-ss-primary fw-800 display-none'/>
                        </div>
                </Col>

                <Col sm='12' md='12' lg='' className='flex-center pb-md-4 pb-lg-5 pb-3'>
                <div className='flex-center'>
                    <div className='grid-center'>
                    <center>
                        <img src='pathogen-testing/RPP-Testing-Workflow-icon7.png' alt='' height='auto' width='80px'  />
                        <div className='flex-center fw-500 text-montserrat text-ss-black fs-ss-16 lh-1-2 pt-2'><center>Results take hours<br/> to days </center></div>
                        </center>
                        <div className='mt-4  d-flex justify-content-center'>
                                <IoIosArrowDown className='fs-ss-36 text-ss-primary fw-800 display-block1-1'/>
                            </div>
                        </div>
                    </div>
                        <div className='ms-md-4'>
                            <IoIosArrowForward className='fs-ss-36 text-ss-primary fw-800 display-none'/>
                        </div>
                </Col>

                <Col sm='12' md='12' lg='' className='flex-center pb-md-4 pb-lg-5 pb-3'>
                <div className='flex-center'>
                    <div className='grid-center'>
                    <center>
                        <img src='pathogen-testing/RPP-Testing-Workflow-icon8.png' alt='' height='auto' width='80px'  />
                        <div className='flex-center fw-500 text-montserrat text-ss-black fs-ss-16 lh-1-2 pt-2'><center>Individual results in<br/> separate reports</center></div>
                        </center>
                        <div className='mt-4  d-flex justify-content-center'>
                                <IoIosArrowDown className='fs-ss-36 text-ss-primary fw-800 display-block1-1'/>
                            </div>
                        </div>
                    </div>
                        <div className='ms-md-4'>
                            <IoIosArrowForward className='fs-ss-36 text-ss-primary fw-800 display-none'/>
                        </div>
                </Col>

                <Col sm='12' md='12' lg='' className='flex-center pb-md-4 pb-lg-5 pb-3'>
                <div className='flex-center'>
                    <div className='grid-center'>
                    <center>
                        <img src='pathogen-testing/RPP-Testing-Workflow-icon5.png' alt='' height='auto' width='90px'  />
                        <div className='flex-center fw-500 text-montserrat text-ss-black fs-ss-16 lh-1-2 pt-2'><center>Less than optimal<br/> care </center></div>
                        </center>
                        
                        </div>
                    </div>
                      
                </Col>
            </Row>
        </div>
    </div>
</div>
  )
}

export default PathogenSyndromicTesting